ready(function(){
	const mapEl = document.getElementById('map');

	if (mapEl) {

		// -- Browser support --
		if (!mapboxgl.supported()) {

    	// -- WebGL no support --
			const noSupportEl = document.querySelector('.mapbox_no_support');
			noSupportEl.classList.remove('hidden');

		} else {

    	// -- WebGL supported --
			// -- Token --
			mapboxgl.accessToken = 'pk.eyJ1IjoiZXZlcnl0aGluZ2lzZnVuIiwiYSI6IkVkalZJRUkifQ.i_Taxju9f5wO9aUyOF7Gyg';

			// -- Init map bounds --
			var bounds = new mapboxgl.LngLatBounds();

			// -- Init map --
			var map = new mapboxgl.Map({
				container: 'map',
				style: 'mapbox://styles/everythingisfun/clsir2d07003i01qw8bfxfwhr',
				center: [6, 49.76],
				zoom: 8,
				minZoom: 8,
				maxZoom: 11,
			});

			map.on('load', function () {

				// -- Add sources --
				map.addSource('citiesSrc', {
					type: 'geojson',
					data: geojson,
				});

				// -- Add a cantons layer (without cluster) --
				map.addLayer({
					"id": "unclustered-point",
					"type": "symbol",
					"source": "citiesSrc",
					"filter": ["!has", "point_count"],
					"layout": {
						"text-field": "{name}",
						"text-anchor": "top",
						"text-font": ['Circular Std Black Regular'],
						"text-size": 10,
						"text-offset": [0, 1],
						"icon-allow-overlap": true
					},
					"paint": {
						"text-color": '#000339',
					},
				});

				// -- Loop geojson data --
				geojson.features.forEach(function (feature) {

					// -- Add markers to bounds --
					bounds.extend(feature.geometry.coordinates);

					// -- Create popup --
					const popup = new mapboxgl.Popup({ offset: 25 }).setHTML(
						`<h2>${feature.properties.title}</h2><ul><li><strong>${feature.properties.hoursTitle} : </strong>${feature.properties.hours}</li><li><strong>${feature.properties.placesTitle} : </strong>${feature.properties.places}</li></ul><a href="${feature.properties.url}" target="_blank" rel="noopener noreferrer" onclick="var otherWindow = window.open(); otherWindow.opener = null; otherWindow.location = href; return false;" class="cta">En savoir plus</a>`
						);

					// -- Create markers --
					const el = document.createElement('div');
					el.className = 'marker';

					// -- Add custom marker with popup to the map --
					const marker = new mapboxgl.Marker(el)
					.setLngLat(feature.geometry.coordinates)
					.setPopup(popup)
					.addTo(map);

				});

				// -- Fit map to marker --
				map.fitBounds(bounds, { padding: 60 });

			});
		}
	}

});